import React, { FC } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import useInfiniteScrollFetcher from "../hooks/useInfiniteScrollFetcher";
import useResponsive from "../hooks/useResponsive";
import { SkeletonRepsLoading } from "./ui-elements/skeleton-loading";
import { apiGetSignatures } from "../api/dashboard";
import { GetSignaturesData } from "../interface/dashboard";

const initialParams = {
  page: 1,
  page_size: 10,
  petition_id: 0,
};

const PetitionSignatures = ({
  author_id,
  petition_id,
}: {
  author_id: number;
  petition_id: number;
}) => {
  const isSmall = useResponsive("down", "sm", "xl");

  const { items, sentryRef, loading, updateParams } =
    useInfiniteScrollFetcher<GetSignaturesData>({
      fetchData: apiGetSignatures,
      initialParams: {
        page: 1,
        page_size: 10,
        petition_id: petition_id,
      },
    });

  return (
    <Box
      sx={{
        border: "1px solid rgba(231, 235, 239, 1)",
        mt: 2,
        borderRadius: "8px",
        px: 2,
        minHeight: 250,
        height: "100%",
        overflowY: "auto",
        width: isSmall ? 300 : "100%",
      }}
    >
      <Typography sx={{ fontWeight: 500, mt: 2 }} variant="h6" color="black">
        Signatures
      </Typography>

      <Box sx={{}}>
        <Divider sx={{ my: 2 }} />
        {loading && items?.length === 0 && (
          <Box sx={{}}>
            {[...Array(3)].map((_, idx) => (
              <SkeletonRepsLoading key={idx} />
            ))}
          </Box>
        )}
        {items?.map((sign, id) => (
          <SignaturesContents
            key={id}
            id={sign?.id}
            image={sign.photo_url}
            name={sign.name}
          />
        ))}
        {items?.length === 0 && (
          <Box
            sx={{
              height: 150,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontSize: 500 }}>
              Petition has not been signed
            </Typography>
          </Box>
        )}
      </Box>
      {/* CircularProgress loader */}
      <div ref={sentryRef} style={{}}>
        {loading && (
          <Box sx={{}}>
            <SkeletonRepsLoading />
          </Box>
        )}
      </div>
    </Box>
  );
};

export default PetitionSignatures;

const SignaturesContents: FC<{
  image: any;
  name: string;
  id: number; // Placeholder for representative ID
}> = ({ image, name, id }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          my: 2,
        }}
      >
        <Stack>
          <img
            src={image}
            alt=""
            width={40}
            height={40}
            style={{ borderRadius: "50%" }}
          />
        </Stack>
        <Stack>
          <Stack direction={"row"} sx={{ gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }} color="black">
              {name}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Divider sx={{ my: 2 }} />
    </>
  );
};
